export enum TaxEntryType {
  US_TAX = 'US_TAX',
  NO_TAX = 'NO_TAX',
  FOREIGN_TAX_RESIDENCY = 'FOREIGN_TAX_RESIDENCY',
  FOREIGN_NON_TAX_RESIDENCY = 'FOREIGN_NON_TAX_RESIDENCY',
  FOREIGN_INDICIA_EXPLANATION = 'FOREIGN_INDICIA_EXPLANATION',
}

export enum TaxNumberTypeCode {
  BIR = 'BIR',
  TIN = 'TIN',
  TPN = 'TPN',
  CRIB = 'CRIB',
  FIN = 'FIN',
  OTHER = 'OTHER',
  SSN = 'SSN',
  ITIN = 'ITIN',
}

export enum UsTaxNoReturnReasonCode {
  RENOUNCED_CITIZENSHIP = 'RENOUNCED_CITIZENSHIP',
  RENOUNCED_GREEN_CARD = 'RENOUNCED_GREEN_CARD',
  US_ADDRESS_TEMPORARY_ONLY = 'US_ADDRESS_TEMPORARY_ONLY',
  EXEMPT_UNDER_TAX_TREATY = 'EXEMPT_UNDER_TAX_TREATY',
  OTHER = 'OTHER',
}

export enum IndiciaReasonCode {
  HOLD_CITIZENSHIP_ONLY_DO_NOT_LIVE_THERE = 'HOLD_CITIZENSHIP_ONLY_DO_NOT_LIVE_THERE',
  NEVER_LIVED_THERE = 'NEVER_LIVED_THERE',
  NO_LONGER_LIVE_THERE = 'NO_LONGER_LIVE_THERE',
  NOT_TAX_RESIDENT_UNDER_RULES = 'NOT_TAX_RESIDENT_UNDER_RULES',
  BORN_THERE_NEVER_LIVED_THERE = 'BORN_THERE_NEVER_LIVED_THERE',
  DO_NOT_LIVE_IN_COUNTRY = 'DO_NOT_LIVE_IN_COUNTRY',
  NOT_TAX_RESIDENT = 'NOT_TAX_RESIDENT',
  TEMPORARY_ADDRESS_ONLY = 'TEMPORARY_ADDRESS_ONLY',
  NO_LONGER_LIVE_AT_ADDRESS = 'NO_LONGER_LIVE_AT_ADDRESS',
  WORK_THERE_TEMPORARILY_ONLY = 'WORK_THERE_TEMPORARILY_ONLY',
  EMPLOYMENT_DOES_NOT_CREATE_TAX_RESIDENCY = 'EMPLOYMENT_DOES_NOT_CREATE_TAX_RESIDENCY',
  LIMITED_BUSINESS_ACTIVITY = 'LIMITED_BUSINESS_ACTIVITY',
  OTHER = 'OTHER',
}

export enum NoTaxNumberReasonCategory {
  COUNTRY_DOES_NOT_ISSUE_TIN = 'COUNTRY_DOES_NOT_ISSUE_TIN',
  UNABLE_TO_PROVIDE_NOW = 'UNABLE_TO_PROVIDE_NOW',
  NOT_LEGALLY_REQUIRED = 'NOT_LEGALLY_REQUIRED',
}

export enum NoTaxNumberReasonCode {
  COUNTRY_DOES_NOT_ISSUE_TIN = 'COUNTRY_DOES_NOT_ISSUE_TIN',
  NEW_RESIDENT_NO_TIN_YET = 'NEW_RESIDENT_NO_TIN_YET',
  OTHER_UNABLE_TO_PROVIDE = 'OTHER_UNABLE_TO_PROVIDE',
  INCOME_BELOW_THRESHOLD = 'INCOME_BELOW_THRESHOLD',
  NOT_REQUIRED_TO_FILE_RETURNS = 'NOT_REQUIRED_TO_FILE_RETURNS',
  RETIRED = 'RETIRED',
  NO_TAXABLE_INCOME = 'NO_TAXABLE_INCOME',
  MINOR_OR_DEPENDENT = 'MINOR_OR_DEPENDENT',
  TIN_ONLY_FOR_SPECIFIC_CATEGORIES = 'TIN_ONLY_FOR_SPECIFIC_CATEGORIES',
  LEGAL_EXEMPTION = 'LEGAL_EXEMPTION',
}

export enum NoTaxResidencyReasonCode {
  TEMPORARY_LIVING = 'TEMPORARY_LIVING',
  TEMPORARY_WORK = 'TEMPORARY_WORK',
  STUDYING_OR_TRAINING = 'STUDYING_OR_TRAINING',
  REMOTE_WORK_NO_LOCAL_PRESENCE = 'REMOTE_WORK_NO_LOCAL_PRESENCE',
  INSUFFICIENT_DAYS = 'INSUFFICIENT_DAYS',
  LEGAL_TAX_EXEMPTION = 'LEGAL_TAX_EXEMPTION',
  OTHER = 'OTHER',
}

export type TaxInfoEntry = {
  countryCode: string;
  taxEntryType: TaxEntryType;
  isCompleted?: boolean;
  usTaxReturnRequired?: boolean;
  usTaxNoReturnReasonCode?: UsTaxNoReturnReasonCode;
  usTaxNoReturnReasonOther?: string;
  taxNumberTypeCode?: TaxNumberTypeCode;
  taxNumberValue?: string;
  otherTaxNumberType?: string;
  noTaxNumberReasonCategory?: NoTaxNumberReasonCategory;
  noTaxNumberReasonCode?: NoTaxNumberReasonCode;
  noTaxNumberReasonOther?: string;
  noTaxResidencyReasonCode?: NoTaxResidencyReasonCode;
  noTaxResidencyReasonOther?: string;
  indiciaReasonCode?: string;
  indiciaReasonOther?: string;
  hasResidenceInOtherCountry?: boolean;
};

export type TaxInfoRequestPayload = TaxInfoEntry[];
